import { createApp } from 'vue';
import axios from 'axios';
import CareerReadinessPurchase from './components/CareerReadinessPurchase.vue';

// bootstrap.js does not set axios up globally, so wire the CSRF header here from
// the <meta name="csrf-token"> the checkout layout emits.
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

const mountEl = document.getElementById('checkout-app');
if (mountEl) {
    const app = createApp({});
    app.component('career-readiness-purchase', CareerReadinessPurchase);
    app.mount('#checkout-app');
}
